module.exports = __webpack_public_path__ + "img/orlova.936683bd.jpg";